import { render, staticRenderFns } from "./SordoCiego.vue?vue&type=template&id=2fa6dab4&scoped=true"
import script from "./SordoCiego.vue?vue&type=script&lang=js"
export * from "./SordoCiego.vue?vue&type=script&lang=js"
import style0 from "./SordoCiego.vue?vue&type=style&index=0&id=2fa6dab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa6dab4",
  null
  
)

export default component.exports